import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'

const config = require('@/config')

/**
 * Calls the support assistant API (fc-support-bot) with the signed-in admin's own Firebase token.
 * Resolves with the response, rejects with an Error whose message is the server's error text when there is one.
 */
export default function supportApi(method, path, data) {
  return firebase.auth().currentUser.getIdToken(false).then(idToken => axios({
    method,
    url: `${config.supportURL}${path}`,
    data,
    headers: { Authorization: idToken },
    timeout: 30000,
  })).catch(error => {
    const serverMessage = error.response && error.response.data && error.response.data.error
    if (serverMessage) {
      throw new Error(serverMessage)
    }
    if (error.response && error.response.status === 401) {
      throw new Error('Not authorised for the support service (admin role required)')
    }
    if (!error.response) {
      throw new Error('Support service not reachable')
    }
    throw error
  })
}
